import { css } from "@emotion/react";

import theme from "../../styles/theme";

export const label = css`
  display: flex;
`;

export const icon = css`
  margin-left: ${theme.spacing(1)}px;
`;

export const requiredStyles = css`
  color: red;
  margin-right: 1px;
`;
